//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { UniversalPostType } from '@apis/universal-posts/universalPostsApiModel';
import { getSocialNetworkFromPostType } from '@apis/universal-posts/universalPostsUtils';
import { IMlsMediaItem } from '@models/IMlsMediaItem';
import { SocialNetwork, getSocialNetworkName } from '@models/SocialNetwork';
import { isYouTubeShortsVideo } from '@universal-scheduling/components/scheduler/post-details-tabs/postDetailsTabUtils';
import { isDefined } from '@utils/filterPredicates';

export const SchedulerNetworkSortOrder: Record<
  keyof typeof SocialNetwork,
  number
> = {
  [SocialNetwork.Instagram]: 0,
  [SocialNetwork.TikTok]: 1,
  [SocialNetwork.Facebook]: 2,
  [SocialNetwork.Pinterest]: 3,
  [SocialNetwork.Twitter]: 4,
  [SocialNetwork.Tumblr]: 5,
  [SocialNetwork.Snapchat]: 6,
  [SocialNetwork.YouTube]: 7,
  [SocialNetwork.Unknown]: 8,
  [SocialNetwork.Bazaarvoice]: 9,
};

export const schedulerSocialNetworkSorter = (
  networkA: SocialNetwork,
  networkB: SocialNetwork,
) => {
  return (
    SchedulerNetworkSortOrder[networkA] - SchedulerNetworkSortOrder[networkB]
  );
};

export const getSocialNetworkPostTypeName = (
  postType: UniversalPostType,
  mediaItems?: IMlsMediaItem[],
) => {
  const network = getSocialNetworkFromPostType(postType);
  switch (network) {
    case SocialNetwork.Instagram:
      if (isDefined(postType)) {
        switch (postType) {
          case UniversalPostType.InstagramStoryGroupAutomaticPost:
          case UniversalPostType.InstagramStoryGroupPost:
            return 'Instagram Story';
          case UniversalPostType.InstagramReelsAutomaticPost:
          case UniversalPostType.InstagramReelsManualPost:
            return 'Instagram Reel';
          case UniversalPostType.InstagramFeedAutomaticPost:
          case UniversalPostType.InstagramFeedManualPost:
          default:
            break;
        }
      }
      return 'Instagram';
    case SocialNetwork.YouTube:
      return `YouTube ${getYouTubePostTypeFromMedia(mediaItems?.[0])}`;
    default:
      return getSocialNetworkName(network);
  }
};

export const getYouTubePostTypeFromMedia = (mediaItem?: IMlsMediaItem) => {
  return isYouTubeShortsVideo(mediaItem) ? 'Shorts' : 'Video';
};
